import { IExcelStyles } from "./IExcelStyles.type";

/**
 * Default Excel styles for exports.
 * - fontSize: applied to all cells (header and body)
 * - headerStyles: applied to header rows only (colors, bold)
 *
 * Add new header styles to headerStyles to make them available across all exports.
 */
export const ExcelStyles: IExcelStyles = {
    fontSize: 11,
    headerStyles: [
        {
            id: 'default',
            fontColor: 'FFFFFFFF', // White
            fillColor: '66666666', // Gray
            bold: true
        },
        {
            id: 'red',
            fontColor: 'FFFFFFFF', // White
            fillColor: 'FFFF0000', // Red
            bold: true
        },
        {
            id: 'green',
            fontColor: 'FFFFFFFF', // White
            fillColor: 'FF008000', // Green
            bold: true
        },
        {
            id: 'yellow',
            fontColor: 'FF000000', // Black
            fillColor: 'FFFFFF00', // Yellow
            bold: false
        },
        {
            id: 'disabled',
            fontColor: 'FF888888', // Dark gray font
            fillColor: 'FFD3D3D3', // Light gray fill - indicates column is not editable for current change type
            bold: false
        }
    ]
};

/**
 * Get the default header style
 */
export function getDefaultHeaderStyle() {
    return ExcelStyles.headerStyles.find(s => s.id === 'default') || ExcelStyles.headerStyles[0];
}

/**
 * Common color palette for creating custom styles
 * Use these constants to ensure consistency across exports
 */
export const ExcelColors = {
    // Font Colors
    FontWhite: 'FFFFFFFF',
    FontBlack: 'FF000000',

    // Fill Colors
    FillGray: '66666666',
    FillRed: 'FFFF0000',
    FillOrange: 'FFFFA500',
    FillYellow: 'FFFFFF00',
    FillGreen: 'FF008000',
    FillBlue: 'FF0000FF',
    FillPurple: 'FF800080',
    FillLightGray: 'FFD3D3D3',
    FillDarkGray: 'FF404040'
};
